// src/pages/bloomterminal/alerts/assets/alertTypeIcons.jsx
// Alert type icons from Figma - SVG components

import React from 'react';

export const PriceIncreaseIcon = ({ size = 16, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    preserveAspectRatio="none"
    style={{ display: 'block', overflow: 'visible' }}
  >
    <g clipPath="url(#clip0_price_increase)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.728 6.70286C15.8247 6.64329 15.9015 6.55624 15.9485 6.45283C15.9956 6.34942 16.0107 6.23434 15.992 6.12229L15.2377 1.61943C15.2252 1.54463 15.1979 1.47308 15.1574 1.40894C15.1169 1.3448 15.0641 1.28936 15.002 1.24585C14.9398 1.20235 14.8697 1.17164 14.7956 1.15553C14.7214 1.13941 14.6449 1.13821 14.5703 1.152L10.296 1.94629C10.1865 1.9667 10.0854 2.01866 10.0051 2.09576C9.92474 2.17287 9.86868 2.27177 9.84379 2.38031C9.81891 2.48885 9.82627 2.60229 9.86499 2.7067C9.9037 2.81111 9.97208 2.90193 10.0617 2.968L11.9497 4.36L8.69714 9.00571L5.728 6.92343C5.57293 6.81488 5.3811 6.77232 5.19467 6.80511C5.00824 6.8379 4.84245 6.94334 4.73371 7.09829L0.128 13.672C0.0741956 13.7488 0.0360531 13.8355 0.0157505 13.9271C-0.00455217 14.0187 -0.00661743 14.1134 0.00967262 14.2058C0.0259627 14.2981 0.060289 14.3864 0.110692 14.4655C0.161094 14.5446 0.226587 14.6131 0.303429 14.6669C0.458618 14.7755 0.650618 14.8181 0.83719 14.7852C0.929571 14.7689 1.01784 14.7346 1.09695 14.6842C1.17607 14.6338 1.24448 14.5683 1.29829 14.4914L5.49257 8.50286L8.46171 10.5851C8.61693 10.6936 8.80885 10.736 8.99529 10.7029C9.18173 10.6699 9.34744 10.5643 9.456 10.4091L13.0983 5.20914L15.088 6.67657C15.1797 6.74414 15.2896 6.78275 15.4034 6.78743C15.5172 6.79212 15.6299 6.76266 15.7269 6.70286"
        fill="#EC3460"
      />
    </g>
    <defs>
      <clipPath id="clip0_price_increase">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PriceDropIcon = ({ size = 16, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    preserveAspectRatio="none"
    style={{ display: 'block', overflow: 'visible', transform: 'scaleY(-1)' }}
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.728 6.70286C15.8247 6.64329 15.9015 6.55624 15.9485 6.45283C15.9956 6.34942 16.0107 6.23434 15.992 6.12229L15.2377 1.61943C15.2252 1.54463 15.1979 1.47308 15.1574 1.40894C15.1169 1.3448 15.0641 1.28936 15.002 1.24585C14.9398 1.20235 14.8697 1.17164 14.7956 1.15553C14.7214 1.13941 14.6449 1.13821 14.5703 1.152L10.296 1.94629C10.1865 1.9667 10.0854 2.01866 10.0051 2.09576C9.92474 2.17287 9.86868 2.27177 9.84379 2.38031C9.81891 2.48885 9.82627 2.60229 9.86499 2.7067C9.9037 2.81111 9.97208 2.90193 10.0617 2.968L11.9497 4.36L8.69714 9.00571L5.728 6.92343C5.57293 6.81488 5.3811 6.77232 5.19467 6.80511C5.00824 6.8379 4.84245 6.94334 4.73371 7.09829L0.128 13.672C0.0741956 13.7488 0.0360531 13.8355 0.0157505 13.9271C-0.00455217 14.0187 -0.00661743 14.1134 0.00967262 14.2058C0.0259627 14.2981 0.060289 14.3864 0.110692 14.4655C0.161094 14.5446 0.226587 14.6131 0.303429 14.6669C0.458618 14.7755 0.650618 14.8181 0.83719 14.7852C0.929571 14.7689 1.01784 14.7346 1.09695 14.6842C1.17607 14.6338 1.24448 14.5683 1.29829 14.4914L5.49257 8.50286L8.46171 10.5851C8.61693 10.6936 8.80885 10.736 8.99529 10.7029C9.18173 10.6699 9.34744 10.5643 9.456 10.4091L13.0983 5.20914L15.088 6.67657C15.1797 6.74414 15.2896 6.78275 15.4034 6.78743C15.5172 6.79212 15.6299 6.76266 15.7269 6.70286"
        fill="var(--bloom-green)"
      />
    </g>
  </svg>
);

export const VolumeChangeIcon = ({ size = 16, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    preserveAspectRatio="none"
    style={{ display: 'block', overflow: 'visible' }}
  >
    <g>
      <path
        d="M7.66667 3H14.3333M1.66667 5.33333L4.33333 2.66667V14M7.66667 6.33333H13M7.66667 9.66667H11.6667M7.66667 13H10.3333"
        stroke="#E770DD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const WeatherImpactIcon = ({ size = 16, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    preserveAspectRatio="none"
    style={{ display: 'block', overflow: 'visible' }}
  >
    <g clipPath="url(#clip0_weather_impact)">
      <path
        d="M8 1.5V0.5M12.596 3.404L13.3033 2.69667M14.5 8H15.5M12.596 12.596L13.3033 13.3033M8 14.5V15.5M3.404 12.596L2.69667 13.3033M1.5 8H0.5M3.404 3.404L2.69667 2.69667M3.5 8C3.5 9.19347 3.97411 10.3381 4.81802 11.182C5.66193 12.0259 6.80653 12.5 8 12.5C9.19347 12.5 10.3381 12.0259 11.182 11.182C12.0259 10.3381 12.5 9.19347 12.5 8C12.5 6.80653 12.0259 5.66193 11.182 4.81802C10.3381 3.97411 9.19347 3.5 8 3.5C6.80653 3.5 5.66193 3.97411 4.81802 4.81802C3.97411 5.66193 3.5 6.80653 3.5 8Z"
        stroke="#FEF574"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_weather_impact">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SeasonalIcon = ({ size = 16, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    preserveAspectRatio="none"
    style={{ display: 'block', overflow: 'visible' }}
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.66667 1.33333C5.43623 1.33325 5.21284 1.41276 5.03427 1.55841C4.8557 1.70406 4.73291 1.90692 4.68667 2.13267C4.6692 2.21846 4.63501 2.29998 4.58604 2.37256C4.53707 2.44514 4.47428 2.50737 4.40126 2.55569C4.32825 2.60401 4.24643 2.63747 4.16048 2.65416C4.07453 2.67086 3.98613 2.67047 3.90033 2.653C3.81454 2.63553 3.73302 2.60134 3.66044 2.55237C3.58786 2.5034 3.52563 2.44062 3.47731 2.3676C3.42899 2.29458 3.39553 2.21276 3.37884 2.12681C3.36214 2.04086 3.36253 1.95246 3.38 1.86667C3.4683 1.43411 3.6775 1.03547 3.98331 0.717058C4.28912 0.398646 4.67898 0.173526 5.10763 0.0678421C5.53627 -0.0378414 5.9861 -0.0197507 6.40488 0.120013C6.82365 0.259777 7.19418 0.515478 7.47343 0.857419C7.75268 1.19936 7.9292 1.61351 7.98247 2.05176C8.03575 2.49002 7.9636 2.93439 7.7744 3.33328C7.58521 3.73217 7.28673 4.06919 6.91364 4.30522C6.54054 4.54124 6.10815 4.66658 5.66667 4.66667H2C1.82319 4.66667 1.65362 4.59643 1.5286 4.4714C1.40357 4.34638 1.33333 4.17681 1.33333 4C1.33333 3.82319 1.40357 3.65362 1.5286 3.5286C1.65362 3.40357 1.82319 3.33333 2 3.33333H5.66667C5.93188 3.33333 6.18624 3.22798 6.37377 3.04044C6.56131 2.8529 6.66667 2.59855 6.66667 2.33333C6.66667 2.06812 6.56131 1.81376 6.37377 1.62623C6.18624 1.43869 5.93188 1.33333 5.66667 1.33333ZM11 4C10.7696 3.99992 10.5462 4.07943 10.3676 4.22508C10.189 4.37073 10.0662 4.57358 10.02 4.79933C10.0026 4.88513 9.96843 4.96666 9.9195 5.03925C9.87057 5.11185 9.80782 5.1741 9.73483 5.22245C9.66185 5.2708 9.58005 5.3043 9.49412 5.32104C9.40819 5.33777 9.3198 5.33742 9.234 5.32C9.1482 5.30258 9.06668 5.26843 8.99408 5.2195C8.92148 5.17057 8.85923 5.10782 8.81088 5.03483C8.76253 4.96185 8.72903 4.88005 8.7123 4.79412C8.69556 4.70818 8.69591 4.6198 8.71333 4.534C8.80151 4.10138 9.01062 3.70265 9.31638 3.38414C9.62213 3.06563 10.012 2.8404 10.4406 2.73462C10.8693 2.62884 11.3192 2.64685 11.738 2.78656C12.1568 2.92627 12.5274 3.18194 12.8067 3.52388C13.086 3.86581 13.2626 4.27998 13.3159 4.71826C13.3692 5.15655 13.2971 5.60096 13.1079 5.99988C12.9187 6.39881 12.6202 6.73586 12.2471 6.9719C11.874 7.20794 11.4415 7.33327 11 7.33333H0.666667C0.489856 7.33333 0.320286 7.26309 0.195262 7.13807C0.0702379 7.01305 0 6.84348 0 6.66667C0 6.48986 0.0702379 6.32029 0.195262 6.19526C0.320286 6.07024 0.489856 6 0.666667 6H11C11.2652 6 11.5196 5.89464 11.7071 5.70711C11.8946 5.51957 12 5.26522 12 5C12 4.73478 11.8946 4.48043 11.7071 4.29289C11.5196 4.10536 11.2652 4 11 4ZM7.35333 11.2007C7.39129 11.386 7.48104 11.5567 7.61216 11.6931C7.74327 11.8295 7.91038 11.9258 8.09407 11.971C8.27776 12.0162 8.47051 12.0084 8.64993 11.9484C8.82935 11.8885 8.98808 11.7789 9.1077 11.6323C9.22731 11.4858 9.30291 11.3083 9.32571 11.1205C9.3485 10.9327 9.31756 10.7423 9.23648 10.5714C9.1554 10.4005 9.02751 10.2561 8.86764 10.1549C8.70778 10.0538 8.5225 10.0001 8.33333 10H4C3.82319 10 3.65362 9.92976 3.5286 9.80474C3.40357 9.67971 3.33333 9.51014 3.33333 9.33333C3.33333 9.15652 3.40357 8.98695 3.5286 8.86193C3.65362 8.7369 3.82319 8.66667 4 8.66667H8.33333C8.77485 8.66673 9.20729 8.79206 9.58041 9.0281C9.95354 9.26414 10.252 9.60119 10.4412 10.0001C10.6304 10.399 10.7026 10.8435 10.6493 11.2817C10.5959 11.72 10.4194 12.1342 10.1401 12.4761C9.86075 12.8181 9.49015 13.0737 9.07132 13.2134C8.6525 13.3531 8.20262 13.3712 7.77397 13.2654C7.34531 13.1596 6.95546 12.9344 6.64971 12.6159C6.34395 12.2973 6.13484 11.8986 6.04667 11.466C6.01148 11.2927 6.04657 11.1126 6.14421 10.9652C6.24186 10.8178 6.39406 10.7152 6.56733 10.68C6.74061 10.6448 6.92076 10.6799 7.06817 10.7775C7.21557 10.8752 7.31815 11.0274 7.35333 11.2007Z"
        fill="#A4DFFF"
      />
    </g>
  </svg>
);

export const CheckmarkIcon = ({ size = 16, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    preserveAspectRatio="none"
    style={{ display: 'block', overflow: 'visible' }}
  >
    <g>
      <path
        d="M9.765 3.205C9.9095 3.34161 9.99384 3.53001 9.99946 3.72879C10.0051 3.92756 9.93155 4.12044 9.795 4.265L5.545 8.765C5.47612 8.8378 5.39335 8.89606 5.30157 8.93633C5.2098 8.9766 5.11088 8.99807 5.01067 8.99947C4.91045 9.00087 4.81098 8.98217 4.71811 8.94447C4.62525 8.90678 4.54088 8.85085 4.47 8.78L2.22 6.53C2.08752 6.38783 2.0154 6.19978 2.01883 6.00548C2.02225 5.81118 2.10097 5.62579 2.23838 5.48838C2.37579 5.35097 2.56118 5.27225 2.75548 5.26883C2.94978 5.2654 3.13783 5.33752 3.28 5.47L4.985 7.174L8.705 3.235C8.84161 3.0905 9.03001 3.00616 9.22879 3.00054C9.42756 2.99491 9.62044 3.06845 9.765 3.205Z"
        fill="#F0F5F2"
      />
    </g>
  </svg>
);
